// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"38036393","118":"202e1f43","158":"35b35850","538":"3055f6f3","796":"bda13025","939":"ec2ab8b5"}[chunkId] + ".chunk.js";
};